module.exports = __webpack_public_path__ + "static/7eyecatchingindiegamesPYG1-220425e7dba485fad089b162f9717979.png";